import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollsReceivedManager } from "./components/RollsReceivedManager";

export const RollsReceivedPage = () => {
	return (
		<>
			<HelmetDexteel title="Rolls Received" />
			<RollsReceivedManager />
		</>
	);
};
